import React from 'react';
import './AiMlIntro.css';
import aiml from '../../assets/images/aiml.png'; 
// Updated image import

const AiMlIntro = () => {
  return (
    <section className="aiml-intro-section">
      <div className="container">
        <div className="aiml-intro-grid">
          <div className="aiml-text-content">
            <h2 className="aiml-title">Unlock Business Potential with Neuroverse AI's Expert AI & ML Consulting Services</h2>
            <p>
              Our SAP AI and ML consulting services in the USA are designed to transform your data into intelligent decisions. We offer artificial intelligence consulting for businesses, providing custom AI and ML solutions tailored to your needs. Our SAP machine learning consulting solutions empower your organization to leverage advanced technologies for competitive advantage. We provide AI-powered data solutions consulting, enabling data-driven decision-making. Our custom AI and ML consulting services are designed to integrate seamlessly with your existing systems, enhancing efficiency and productivity.
            </p>
          </div>
          <div className="aiml-image-container">
            <img 
              src={aiml}
              alt="AI and Machine Learning" 
              className="aiml-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AiMlIntro;
